// TODO Remove this temporary hack to fix the styling once we can properly address it.
export const fixWalletGridStyling = () => {
	const checkForGrid = setInterval(() => {
		document.querySelectorAll('wallet-grid').forEach(grid => {
			const target = grid?.shadowRoot?.querySelector('div')?.shadowRoot?.querySelector('.margin-vertical-5');
			if (target) {
				target.classList.remove('margin-vertical-5');
				target.classList.add('margin-top-3');
				target.classList.add('margin-bottom-5');
				clearInterval(checkForGrid);
			}
		});
	}, 100);

	setTimeout(() => {
		clearInterval(checkForGrid);
	}, 5000);
}

// TODO

// 1. Remove this hack once there is an option to pass the payment value into the payments modal,
// or to have the payments requested by Wallet and the website align to return the same payment values.

// 2. When Wallet supports turning off the Vehicle Details link when opening the payments modal, use
// that functionality instead and remove it from this function.
export const modifyPaymentModalContent = (removeVdpLink, paymentData) => {
	const checkForModal = setInterval(() => {
		const modalShadowRoot = document.querySelector('wallet-modal')?.shadowRoot?.querySelector('div')?.shadowRoot;

		if (!modalShadowRoot) {
			return;
		}

		if (!modalShadowRoot.querySelector('.first-price')) {
			return;
		}

		if (removeVdpLink) {
			modalShadowRoot.querySelector('[data-cmp="vdp-cta"]')?.parentNode?.remove();
		}

		const {
			loanPayment,
			term,
			apr,
			lenderName = ''
		} = paymentData;

		if (!(loanPayment && apr && term)) {
			return;
		}

		const content = modalShadowRoot.querySelector('.content-preview-summary');
		const rateMarkup = content.querySelector('div');
		const newRateMarkup = `<span class="text-bold margin-right-2">${lenderName}</span><br />${apr}% APR for ${term} mo.`;
		rateMarkup.innerHTML = newRateMarkup;

		if (loanPayment && modalShadowRoot?.querySelector('.first-price')) {
			modalShadowRoot.querySelector('.first-price').innerText = loanPayment;
		}

		clearInterval(checkForModal);
	}, 50);

	// Stops trying after 2500ms to avoid running this forever.
	setTimeout(() => {
		clearInterval(checkForModal);
	}, 2500);
}

export const hideVdpLink = () => {
	modifyPaymentModalContent(true, false);
}
